export default "__VITE_ASSET__DMqYU$Tz__"